import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, RedirectRequest } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { SpinnerService } from './shared/services/spinner.service';
import { Msal } from './shared/services/msal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  public pageTitle = 'Diagnostic Portal';

  public objSpinnerStatus: boolean;

  public statusMessage: string;

  public success = false;

  public isUserAuthorized: boolean;

  public isTokenExpired = false;

  public timerSubscription: Subscription;

  private readonly _destroying$ = new Subject<void>();
  
  public isLoggedIn:boolean;
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    public msal: Msal,
    public router: Router,
    public location: Location,
    public spinService: SpinnerService,
  ) {
    this.processRouteParams();
  }
  
  ngOnInit(): void {
    this.spinService.loaderStatus.subscribe((val: boolean) => {
      this.objSpinnerStatus = val;
    });

    this.isLoggedIn = !!localStorage.getItem("MSALToken") && !this.msal.IsTokenExpired();
    if (this.isLoggedIn)
    {
      this.processAfterLogin();
    }

    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) =>
       msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
       ),
      takeUntil(this._destroying$)
    )
    .subscribe((result: EventMessage) => {
      this.spinService.displayLoader(true);
      // do something with the result, such as accessing ID token
      const payload = result.payload as AuthenticationResult;
      this.authService.instance.setActiveAccount(payload.account);
      this.msal.getProfile(payload);
      this.isLoggedIn = !!localStorage.getItem("MSALToken") && !this.msal.IsTokenExpired();
      this.processAfterLogin();
    });
  }

  private processAfterLogin(){
          // start 1s after web load, and every 10mins check the page if user still authorized, as well as is token expired
          const timer = Observable.timer(1000, 600000);
          this.timerSubscription = timer.subscribe((t) => {
            this.success = true;
            if (this.msal.IsTokenExpired()) {
              this.isTokenExpired = true;
            } else {
              this.isUserAuthorized = true;
            }
            this.spinService.displayLoader(false);
          });
  }

  public loginRedirect() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }
  
  private processRouteParams() {
    const params: string[] = this.location.path(true).split('/');
    if (params[1] !== undefined) {
      if (params[2] === undefined) {
        this.router.navigate([params[1]]);
        return;
      }

      if (params[3] === undefined) {
        this.router.navigate([params[1], params[2]]);
        return;
      }
      if (params[4] === undefined) {
        this.router.navigate([params[1], params[2], params[3]]);
      } else {
        this.router.navigate([params[1], params[2], params[3], params[4]]);
      }
    }
  }

  public refresh() {
    window.location.reload();
  }

  ngOnDestroy() {
    this._destroying$.next(null);
    this._destroying$.complete();

    // Destroy timer after leaving this component
    this.timerSubscription.unsubscribe();
  }
}
